export const RouterLinks = {
  root: '/',

  auth: '/auth',
  login: '/auth/login',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',

  // registration
  signup: '/signup',
  registerationAccountType: '/signup/accounts/account-type',
  registerationTerms: '/signup/accounts/terms',
  registerationFCADetails: '/signup/accounts/advisor-details',
  registerationPersonalDetails: '/signup/accounts/registration',
  registerationVerification: '/signup/accounts/verification',
  registerationPasswordSetup: '/signup/accounts/password-set-up',
  signupSuccess: '/signup/success',

  // Register via Mail
  registerPersonalDetails: '/registration/your-details',
  registerViaMailVerification: '/registration/verification',
  registerViaMailPasswordSetup: '/registration/password-set-up',
  registerYourDetails: '/registration/your-details',
  registerVerification: '/registration/verification',
  registerPasswordSetup: '/registration/password-set-up',
  registerSuccess: '/registration/success',

  // ONBOARDING ROUTES / PROFILE SETUP ROUTES
  personalDetails: '/onboarding/personal-details',
  expertiseDetails: '/onboarding/expertise-details',
  qualifications: '/onboarding/qualifications',
  accoladesUpload: '/onboarding/accolades-upload',
  workingPreferences: '/onboarding/working-preferences',
  clientData: '/onboarding/client-data',
  calenderSetup: '/onboarding/calendar-setup',
  termsAndConditions: '/onboarding/terms-and-conditions',

  // MANAGE PORTFOLIO ROUTES
  managePortfolio: '/dashboard/manage-portfolio',
  previewCSV: '/dashboard/manage-portfolio/preview-csv',
  mps: '/dashboard/manage-portfolio/mps',

  // DASHBOARD ROUTES
  dashboard: '/dashboard',
  meetings: '/dashboard/meetings',
  clients: '/dashboard/clients',
  portfolio: '/dashboard/portfolio',
  dashboardTrackAdvise: '/dashboard/track-advise',

  clientProfile: '/dashboard/client-profile',
  clientProfileAiAssistance: '/dashboard/ai-assistance',
  securedMessages: '/dashboard/secured-messages',
  reporting: '/dashboard/reporting',
  inviteClient: '/dashboard/clients/invite-client',
  clientTasks: '/dashboard/client-tasks',
  askAi: '/dashboard/ask-ai',
  askZeta: '/dashboard/ask-zeta',
  notifications: '/dashboard/notifications',

  // FACT-FIND ROUTES
  aboutYou: '/dashboard/about-you',
  factFindInitialMeetingSummary: '/dashboard/fact-find/initial-meeting-summary',
  factFindPersonalInfo: '/dashboard/fact-find/personal-information',
  factFindAssets: '/dashboard/fact-find/assets',
  factFindProtectionSolution: '/dashboard/fact-find/protection-solution',
  factFindExperience: '/dashboard/fact-find/experience',
  factFindSummaryAndNotes: '/dashboard/fact-find/summary-and-notes',
  factFindBeneficiaries: '/dashboard/fact-find/beneficiaries',
  factFindExpenditure: '/dashboard/fact-find/expenditure',
  factFindIncome: '/dashboard/fact-find/income',
  factFindNextSteps: '/dashboard/fact-find/next-steps',
  factFindInvestmentSolution: '/dashboard/fact-find/investment-solution',
  factFindBenefitsAndInsurance: '/dashboard/fact-find/benefits-and-insurance',
  factFindLiabilites: '/dashboard/fact-find/liabilities',
  factFindHealthDetails: '/dashboard/fact-find/health-details',
  factFindFinancialPlanning: '/dashboard/fact-find/financial-planning',
  factFindRiskAssessment: '/dashboard/fact-find/risk-assessment',
  factFindReview: '/dashboard/fact-find/review',
  factFindGenerateReport: '/dashboard/fact-find/generate-report',

  // PROFILE SETUP ROUTES
  profileSetup: '/profile-setup',
  organisationProfile: '/profile-setup/organisation-profile',
  userManagement: '/profile-setup/user-management',
  myProfile: '/profile-setup/my-profile',
  changePassword: '/profile-setup/change-password',
  modelPortfolios: '/profile-setup/model-portfolios',
  riskAssessment: '/profile-setup/risk-assessment',
  financialPlanning: '/profile-setup/financial-planning',
  adviceTemplates: '/profile-setup/advice-templates',
  certificationsAndExpertise: '/profile-setup/certifications-and-expertise',
  certificationsAndExpertiseCert: '/profile-setup/certifications-and-expertise/certifications',
  certificationsAndExpertiseExpertise: '/profile-setup/certifications-and-expertise/expertise',
  certificationsAndExpertiseProfessionalBackground: '/profile-setup/certifications-and-expertise/professional-background',
  firmProfileIncomplete: '/firm-profile-incomplete',

  // managed client -financial plan
  dashboardProtectionPlan: '/dashboard/protection-plan',
  dashboardInvestmentPlan: '/dashboard/investment-plan',

  // MY-TASKS-ROUTES
  myTasks: '/dashboard/my-tasks',
  createSolution: '/dashboard/my-tasks/create-solution',
  report: '/dashboard/my-tasks/report',

  workingHours: '/profile-setup/working-hours',

  // MEETINGS ROUTES
  availability: '/dashboard/meetings/availability',

  // plans page
  upgradePlan: '/upgrade-plan',

  // Others
  forbidden: '/403',

  // Client Portal Routes
  workspace: '/dashboard/workspace',
  buildYourPicture: '/dashboard/build-your-picture',
  goals: '/dashboard/goals',
  factFindPersonalFamily: '/dashboard/fact-find/personal-family',
  factFindIncomeOverview: '/dashboard/fact-find/income',
  factFindAssetsOverview: '/dashboard/fact-find/assets',
  factFindLiabilitiesOverview: '/dashboard/fact-find/liabilities',
  factFindEntitiesOverview: '/dashboard/fact-find/entities',
  factFindProtectionOverview: '/dashboard/fact-find/protection',
  factFindSpendingOverview: '/dashboard/fact-find/spending',
  riskProfile: '/dashboard/risk-profile',
  clientDocumentsDashboard: '/dashboard/documents',
  client360Dashboard: '/dashboard/client-360',
  clientPlans: '/dashboard/plans',
  clientPlanScenario: '/dashboard/plans/:scenarioId',
  clientPutInPlace: '/dashboard/put-in-place',
  gdprAgreement: '/dashboard/gdpr-agreement',
  riskToleranceQuestions: '/dashboard/risk-tolerance-questions',

  //Documents routes

  documents: '/documents',
  uploadDocuments: '/documents/upload-documents',
  selectUploadType: '/documents/select-upload-type',
  scheduleMeeting: '/dashboard/schedule-meeting',
  meetingdetail: '/dashboard/meetingdetail',
  discoverySummary: '/dashboard/discovery-summary',
  secureMessageClient: '/dashboard/secure-message',
};
